import { useState } from "react";
import { AxiosError } from "axios";

// api通信共通エラーハンドリング
export const useApiErrorHandler = () => {
  const [error, setError] = useState<string | null>(null);

  const clearError = () => setError(null);

  // 基本的にユーザー起因の業務エラーは存在しない想定
  const handleError = (error: unknown) => {
    if (error instanceof AxiosError) {
      if (error.response) {
        setError("予期しないエラーが発生しました。しばらく経ってからもう一度お試しください。");
      } else if (error.request) {
        setError("サーバーからの応答がありません。ネットワーク接続を確認してください。");
      }
    } else {
      setError("予期しないエラーが発生しました。しばらく経ってからもう一度お試しください。");
    }
  };

  return {
    error,
    setError,
    clearError,
    handleError,
  };
};
